import React from 'react';

// Blocking notice. Stays until OK, unlike the page banner that is easy to miss.
export default function FailureNotice({ notice, onClose, zIndex = 9999 }) {
  if (!notice) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white', borderRadius: '16px',
          padding: '28px 28px 22px', maxWidth: '480px', width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          textAlign: 'center'
        }}
      >
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%',
          background: 'linear-gradient(135deg, #FEE2E2, #FECACA)',
          border: '2px solid #DC2626',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px'
        }}>
          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '24px', color: '#DC2626' }}></i>
        </div>
        <h3 style={{ margin: '0 0 10px', fontSize: '18px', fontWeight: 700, color: '#1F2937' }}>
          {notice.title}
        </h3>
        <p style={{
          margin: notice.suggestion ? '0 0 12px' : '0 0 22px',
          fontSize: '14px', color: '#4B5563', lineHeight: 1.55
        }}>
          {notice.message}
        </p>
        {notice.suggestion && (
          <p style={{
            margin: '0 0 22px',
            fontSize: '14px',
            color: '#1F2937',
            lineHeight: 1.55,
            textAlign: 'left',
            background: '#F3F4F6',
            borderRadius: 8,
            padding: '10px 12px'
          }}>
            <span style={{ fontWeight: 700 }}>What to do. </span>
            {notice.suggestion}
          </p>
        )}
        <button
          onClick={onClose}
          autoFocus
          style={{
            padding: '10px 32px', borderRadius: '8px', border: 'none',
            background: 'linear-gradient(135deg, #3B82F6, #2563EB)',
            color: 'white', fontWeight: 700, fontSize: '14px',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(59,130,246,0.35)'
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
